import { useEffect, useState } from 'react';
import { buildSortedTree, buildTreeFlat } from '@/util';
import { useGet } from '@/query/fetchHooks';
import { Document, Chapter, Image, Play } from '@teo/components/icons';

export const CourseTree = ({ activeCourse }) => {
  const [tree, setTree] = useState(null);

  // let lessonPath = '/usedlessonassets';

  // if (activeCourse?.id) lessonPath = '/usedcourselessonassets';
  let lessonPath = '/usedlessonassets';
  const lessonResult = useGet(lessonPath, {
    count: 10000,
    coursecontentId: activeCourse?.id,
  });
  const lessons = lessonResult?.data?.data || undefined;
  const directoriesResult = useGet('/directoriedetails', {
    count: 10000,
    coursecontentId: activeCourse?.id,
  });
  const directories = directoriesResult?.data?.data || undefined;

  useEffect(() => {
    if (lessons && directories) {
      const courseLessons = lessons.filter(
        (les) => !les?.rootLessonId && !les?.rootDirectoryId
      );
      const sortedTree = buildSortedTree(courseLessons, directories || []);
      const [newTree] = buildTreeFlat(courseLessons, directories);

      const orderTree = newTree?.map((el) => ({
        id: el?.id,
        label: el?.data?.name || el?.data?.assetName,
        el: el,
      }));

      setTree(orderTree);
    }
  }, [lessons, directories]);

  return (
    <div className="flex max-h-[40vh] flex-col overflow-y-auto py-2">
      {tree?.map((lesIndex, i) => (
        <div key={i} className="rounded-md px-3 py-1 text-base text-black">
          <div
            className="flex items-center rounded-lg bg-grey-01 px-4 py-2 text-sm text-grey-08"
            style={{
              marginLeft: `${
                (lesIndex?.el?.data?.path?.split('/').length - 2) * 24
              }px`,
            }}
          >
            {!lesIndex?.el?.data?.lessonId || false ? (
              lesIndex?.el?.data?.assetId ? (
                lesIndex?.el?.data?.assetType === 'image' ? (
                  <Image className="m-1 w-5 min-w-5 " />
                ) : (
                  <Play className="m-1 w-5 min-w-5 " />
                )
              ) : (
                <Chapter className="m-1 w-5 min-w-5" />
              )
            ) : (
              <Document className={`m-1 w-5 min-w-5`} />
            )}
            <p className={'ml-1 block'}>{lesIndex?.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
